module.exports = __webpack_public_path__ + "static/Gilroy-Thin-d0028c7521b8046166c7f0c94d7059ea.woff2";